import React from 'react';
import PropTypes from 'prop-types';
import CompactCurrencyFilter from '../product/PricingUtils';

const CartInviteSubItem = ({ item }) => (
  <div className="row margin-top-2x">
    {/* <div className="item-image-col col-xs-3 col-sm-2 col-sm-offset-1">
      <img className="img-responsive" src={item.imageLink} alt={item.name} />
    </div> */}
    <div className="item-description-col col-xs-11 col-sm-6">
      <div className="col-md-12">
        <div className="entity-name">{item.name}</div>
        <div className="cart-item-attributes">
          {item.skuAttributes.map(attr => (
            <div className="value-label attribute-value" key={attr.label}>
              <strong>{attr.label}:</strong> {attr.value}
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="shop-entity-details hidden-xs col-sm-2">
      <div className="price value-label attribute-value">
        {CompactCurrencyFilter(item.contribution.adjustedPrice)}
        {item.contribution.adjustedPrice !== 0}
      </div>
      {item.price > item.adjustedPrice && <s className="price value-label attribute-value">{CompactCurrencyFilter(item.contribution.price)}</s>}
    </div>
    <div className="price col-xs-6 col-sm-2 cart-item-quantity text-danger">{item.contribution.quantity}</div>
  </div>
);

CartInviteSubItem.propTypes = {
  item: PropTypes.shape({})
};

export default CartInviteSubItem;



// WEBPACK FOOTER //
// ./src/components/cart/CartInviteSubItem.jsx